import { useContext, useEffect, useRef } from 'react';

import { ApplicationContext } from '@src/app/contexts/Application';

import EligibilityLayout from '../layouts/EligibilityLayout';
import LoanDetailsView from '../views/eligibility/LoanDetailsView';

const LoanDetails = () => {
    const {
        loading,
        loanDetails,
        saveLoanDetails,
        updateStageToFactFind,
        applicationId,
    } = useContext(ApplicationContext);
    const saveRef = useRef(null);

    useEffect(() => {
        async function update() {
            updateStageToFactFind(applicationId);
        }
        update();
        // eslint-disable-next-line
    }, [applicationId]);

    return (
        <EligibilityLayout loading={loading} ref={saveRef}>
            <LoanDetailsView
                ref={saveRef}
                loanDetailsData={loanDetails}
                saveLoanDetails={saveLoanDetails}
            />
        </EligibilityLayout>
    );
};

export default LoanDetails;
